import React from 'react';
import {Row, Col, Input, Table} from 'antd'
import { useTranslation } from 'react-i18next';

const ActividadEco = ({actividadEco={}, actual, forceExpand}) => {
    const { t } = useTranslation();
    const actRecordsCol = [
        {
            title: t("messages.aml.economicActivity"),
            dataIndex: "linea",
            key: 'linea1',
            width: "70%",
            render: (linea) => {
                const arr = linea.slice(7)
                return arr
        }
        },
        {
            title: t("messages.aml.activityCode"),
            dataIndex: "linea",
            key: "linea2",
            width: "22%",
            render: (linea) => {
                const arr = linea.substr(0,6)
                return arr
        }
        },
    ];
    return (
        <div>
            <Row gutter={[32, 12]}>
                <Col span={8}>
                    {t("messages.aml.activityStartDate")}
                    <Input readOnly value={actividadEco.initDate} className={actual && actividadEco.initDate !== actual.initDate && "difference"}/>
                </Col>
                <Col span={8}>
                    {t("messages.aml.marketExperienceYears")}
                    <Input readOnly value={actividadEco.aniosExp} className={actual && actividadEco.aniosExp !== actual.aniosExp && "difference"}/>
                </Col>
                <Col span={8}>
                    {t("messages.aml.mainCommercialActivity")}
                    <Input readOnly value={actividadEco.customActivities} className={actual && actividadEco.customActivities !== actual.customActivities && "difference"}/>
                </Col>
                <Col span={24}>
                    <Table
                        className={actual && actividadEco.actRecords !== actual.actRecords && "difference"}
                        columns={actRecordsCol}
                        dataSource={actividadEco.actRecords}
                        pagination={!forceExpand && actividadEco.actRecords?.length > 10}
                />
                </Col>
            </Row>
        </div>
    );
};

export default ActividadEco;